import React, { lazy, Suspense } from 'react'

import { ModuleService } from '@services/module'
import { IModuleResponse } from '@resources/types/services/module'
import { applyModuleStructure } from '@store/module/structure/slice'
import { applyModuleTheme } from '@store/module/theme/slice'
import { applyModuleBackend } from '@store/module/backend/slice'
import { store } from '@store/index'
import { prepareThemeToStoreApply } from '@resources/utils/theme'
import { getStorage } from '@store/index'
import { IModuleStructureState } from '@store/module/structure/types'

import Loading from './Loading'

const getThemeFromStorage = async () => {
  const themeFromStorage = (await getStorage()) || ''
  const storeStorage = JSON.parse(themeFromStorage)
  const { theme } = JSON.parse(storeStorage.moduleTheme)

  return theme
}

const App = lazy(async (): Promise<any> => {
  const { structure } = store.getState()
    .moduleStructure as IModuleStructureState

  if (!structure?.resources?.loan?.version) {
    const dataConfig = await ModuleService.get()

    if (dataConfig.status === 200) {
      const module = dataConfig.data as IModuleResponse

      const { preparedTheme } = prepareThemeToStoreApply(module.theme)

      store.dispatch(applyModuleTheme(preparedTheme))
      store.dispatch(applyModuleStructure(module.structure))
      store.dispatch(applyModuleBackend(module.backend))
    }
  }

  return new Promise((resolve) => {
    const getRecursiveImportApp = async () => {
      const theme = await getThemeFromStorage()

      setTimeout(() => {
        if (!theme.defaultPallete?.title) {
          getRecursiveImportApp()
          return
        }

        return resolve(
          import('./app').catch(() => {
            getRecursiveImportApp()
            return
          }),
        )
      }, 1500)
    }

    getRecursiveImportApp()
  })
})

const AppView: React.FC = () => {
  return <Suspense fallback={<Loading />}>{<App />}</Suspense>
}

export default AppView
